import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import emailjs from '@emailjs/browser';
import './ContactForm.css';

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

function ContactForm() {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | sending | success | error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
      // eslint-disable-next-line no-console
      console.error(
        'EmailJS is not configured — set REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID, and REACT_APP_EMAILJS_PUBLIC_KEY.'
      );
      setStatus('error');
      return;
    }

    setStatus('sending');
    emailjs
      .send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          from_name: form.name,
          from_email: form.email,
          message: form.message,
          time: new Date().toLocaleString('en-US', {
            dateStyle: 'medium',
            timeStyle: 'short',
          }),
        },
        { publicKey: PUBLIC_KEY }
      )
      .then(() => {
        setStatus('success');
        setForm({ name: '', email: '', message: '' });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('EmailJS send failed:', err);
        setStatus('error');
      });
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="contact-field">
        <label htmlFor="contact-name">{t('pages.about.contactNameLabel')}</label>
        <input
          id="contact-name"
          name="name"
          type="text"
          required
          value={form.name}
          onChange={handleChange}
          placeholder={t('pages.about.contactNamePlaceholder')}
        />
      </div>
      <div className="contact-field">
        <label htmlFor="contact-email">{t('pages.about.contactEmailLabel')}</label>
        <input
          id="contact-email"
          name="email"
          type="email"
          required
          value={form.email}
          onChange={handleChange}
          placeholder={t('pages.about.contactEmailPlaceholder')}
        />
      </div>
      <div className="contact-field">
        <label htmlFor="contact-message">{t('pages.about.contactMessageLabel')}</label>
        <textarea
          id="contact-message"
          name="message"
          rows={5}
          required
          value={form.message}
          onChange={handleChange}
          placeholder={t('pages.about.contactMessagePlaceholder')}
        />
      </div>
      <button type="submit" className="contact-submit" disabled={status === 'sending'}>
        {status === 'sending' ? t('pages.about.contactSending') : t('pages.about.contactSubmit')}
      </button>
      {status === 'success' && (
        <p className="contact-status contact-status--success">{t('pages.about.contactSuccess')}</p>
      )}
      {status === 'error' && (
        <p className="contact-status contact-status--error">{t('pages.about.contactError')}</p>
      )}
    </form>
  );
}

export default ContactForm;
